import { AppUpdateService } from '../Common/Services/app-update.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, inject, NgZone, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { fromEvent, Subject } from 'rxjs';
import { filter, takeUntil, throttleTime } from 'rxjs/operators';
import { SubRolesService } from 'src/app/Common/SubRoleService/sub-roles.service';
import { SubRoleMenuDTO, SubRolesReadByUserIdRequestDTO } from 'src/app/Common/SubRoleService/SubRoles.interface';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { LoaderService } from 'src/app/Shared/loader/loader.service';
import { environment } from 'src/environments/environment';
import { WhiteLabelServiceService } from '../AdvERP/companies/white-label/white-label-service.service';
import { CompanyWhiteLabelDTO } from '../AdvERP/companies/white-label/white-label.interface';
import { CompanycategoryService } from '../Common/CompanyCategoryService/companycategory.service';
import { LocationService } from '../Common/LocationService/location.service';
import { ValueListService } from '../Common/ValueListService/value-list.service';
import { FilteredKeyValueRequestDTO } from '../Common/ValueListService/valuelist.interface';
import { IndividualService } from "src/app/AdvERP/individual/individual.service";
import { BranchMasterDTO, BranchMasterReadByUserIdRequestDTO } from '../Common/BranchMasterService/branchmaster.interface';
import { BranchMasterService } from '../Common/BranchMasterService/branchmaster.service';
import { CustomerSubscriptionsService } from '../AdvERP/companies/company-customer-subscriptions/comapny-customer-subscriptions.service';
import { CustomerSubscriptionsStatusDTO } from '../AdvERP/companies/company-customer-subscriptions/company-customer-subscriptions.interface';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NavigationHistoryService } from '../Shared/navigation-history/navigation-history.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { IndividualMasterReadByUserIdRequestDTO } from '../AdvERP/individual/individual.interface';
import { ApiConfigurationService } from '../Common/ApiConfigurationService/api-configuration.service';
import { attachModernScroll, ModernScrollHandle } from '../Shared/utils/modern-scroll';
import { SupportWidgetVisibilityService } from '../support-desk/support-chat-widget/support-widget-visibility.service';

interface BreadcrumbItem {
  label: string;
  url: string;
  clickable: boolean;
}

/** One searchable page in the menu search (Ctrl+K). `path` is exactly what the sidebar's routerLink uses. */
interface ShellSearchItem {
  label: string;
  trail: string;
  icon: string;
  path: string[];
  group?: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  User = this.userLoginService.User();
  parentMenu: SubRoleMenuDTO[] = [];

  // Sidebar accordion state (expanded mode)
  expandedMenuIdx: number | null = null;
  expandedChildKey: string | null = null;

  // Condensed mode flyout state
  hoveredMenuIdx: number | null = null;
  flyoutY: number = 0;
  /** vertical centre of the hovered rail icon (the pointer notch aims here) */
  flyoutAnchorY: number = 0;
  flyoutHovered: boolean = false;
  flyoutHoveredChildIdx: number | null = null;
  flyoutHoveredSubIdx: number | null = null;
  private flyoutCloseTimer: any = null;

  get hoveredMenu(): SubRoleMenuDTO | null {
    return this.hoveredMenuIdx !== null ? (this.parentMenu[this.hoveredMenuIdx] ?? null) : null;
  }

  toggleMenu(i: number): void {
    this.expandedMenuIdx = this.expandedMenuIdx === i ? null : i;
    this.expandedChildKey = null;
  }

  toggleChild(key: string): void {
    this.expandedChildKey = this.expandedChildKey === key ? null : key;
  }

  onMenuHover(i: number, event: MouseEvent): void {
    if (this.isSidebarEnabled) return;
    clearTimeout(this.flyoutCloseTimer);
    const el = event.currentTarget as HTMLElement;
    const rect = el.getBoundingClientRect();
    this.flyoutY = rect.top;
    this.flyoutAnchorY = rect.top + rect.height / 2;
    this.hoveredMenuIdx = i;
    this.flyoutHoveredChildIdx = null;
    this.flyoutHoveredSubIdx = null;
    this.flyoutHovered = false;
  }

  onMenuLeave(): void {
    this.flyoutCloseTimer = setTimeout(() => {
      if (!this.flyoutHovered) {
        this.hoveredMenuIdx = null;
      }
    }, 100);
  }

  onFlyoutEnter(): void {
    clearTimeout(this.flyoutCloseTimer);
    this.flyoutHovered = true;
  }

  onFlyoutLeave(): void {
    this.flyoutHovered = false;
    this.flyoutCloseTimer = setTimeout(() => {
      this.hoveredMenuIdx = null;
      this.flyoutHoveredChildIdx = null;
      this.flyoutHoveredSubIdx = null;
    }, 100);
  }

  closeFlyout(): void {
    clearTimeout(this.flyoutCloseTimer);
    this.flyoutHovered = false;
    this.hoveredMenuIdx = null;
    this.flyoutHoveredChildIdx = null;
    this.flyoutHoveredSubIdx = null;
  }
  breadcrumbItems: BreadcrumbItem[] = [];
  mobileBreadcrumbHidden = false;
  private readonly destroy$ = new Subject<void>();
  private readonly breadcrumbRouteAliasMap: Record<string, Record<string, string>> = {
    erp: {
      itemsstock: 'item-stock',
      billofmaterial: 'bom'
    }
  };
  private menuById = new Map<number, SubRoleMenuDTO>();


  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userLoginService: UserLoginService,
    private loaderService: LoaderService,
    private subRolesService: SubRolesService,
    private companyCategoryService: CompanycategoryService,
    private valueListService: ValueListService,
    private locationService: LocationService,
    private individualService: IndividualService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private navigationHistoryService: NavigationHistoryService
  ) {
    this.User = this.userLoginService.User();
    this.applyMenuState();   // before the first paint, so a saved "collapsed" does not flash open
  }

  branchMasterService = inject(BranchMasterService)
  BranchList: BranchMasterDTO[] = []
  customerSubscriptionsService = inject(CustomerSubscriptionsService)
  private sanitizer = inject(DomSanitizer)
  private apiConfigurationService = inject(ApiConfigurationService)
  appUpdate = inject(AppUpdateService)
  updateCheckMsg = ''

  // User menu: reload straight away if a newer build is known, else check now.
  async checkForUpdates(): Promise<void> {
    if (this.appUpdate.updateAvailable || await this.appUpdate.check()) {
      this.appUpdate.reload();
      return;
    }
    this.updateCheckMsg = 'You are on the latest version';
    this.cdr.detectChanges();
    setTimeout(() => { this.updateCheckMsg = ''; this.cdr.detectChanges(); }, 3000);
  }

  // Sidebar user dropdown
  userDropdownOpen = false;
  userDropdownStyle: Record<string, string> = {};

  closeUserDropdown(): void {
    this.userDropdownOpen = false;
  }

  // Profile menu > Help & Support: brings back the floating support button if
  // the user dismissed it, and opens its panel.
  private supportWidget = inject(SupportWidgetVisibilityService)
  openHelpSupport(): void {
    this.supportWidget.requestOpen();
  }

  // Subscription status banner
  private subscriptionCheckTimer: any = null;

  // Payment due popup
  private paymentDueData: CustomerSubscriptionsStatusDTO | null = null;
  activePaymentDueAlert: CustomerSubscriptionsStatusDTO | null = null;
  private paymentPopupTimer: any = null;
  paymentQrCodeUrl: SafeUrl = '';
  showPaymentBankDetails = false;
  copiedPaymentField: string | null = null;

  readonly paymentBankDetails = {
    accountNo: '7350335127',
    bankName: 'Kotak Mahindra Bank',
    ifscCode: 'KKBK0002113',
    gstin: '27ABCCA3726D2Z0',
    upiId: 'advinsoftwares@kotak',
    beneficiary: 'Advin Softwares'
  };

  getBranchListForUser() {
    const req: BranchMasterReadByUserIdRequestDTO = {
      tenantId: this.User.companyId,
      actionUser: this.User.userId.toString()
    }

    this.branchMasterService.BranchMaster_readByUserId(req).subscribe(res => {
      this.BranchList = res.items || []
    })

  }

  get currentBranchName(): string {
    const activeBranch = this.BranchList.find(branch => branch.tenantBranchId === this.User.loggedInBranchId);
    return activeBranch?.branchName || '';
  }

  ngOnInit(): void {
    this.setupBreadcrumbTracking();

    if (this.userLoginService.isAuthenticated()) {
      this.loaderService.dismiss()
      this.loaderService.show()

      this.userLoginService.UserLogin_validateToken().subscribe({
        next: (tokenRes) => {
          this.getBranchListForUser();
          tokenRes.loggedInBranchId = Number(localStorage.getItem('loggedInBranchId'))
          this.userLoginService.saveUserData(tokenRes);
          
          // Refresh User reference to get updated loggedInBranchId
          this.User = this.userLoginService.User();

          // Resolve this tenant's ServerPool-assigned gateway URLs before any
          // further API calls fire, so ApiUrlRewriteInterceptor has overrides
          // cached in time. Failure is non-fatal (falls back to compiled-in
          // environment.*BaseURL) — do not block menu loading on it.
          if (this.User.companyId) {
            this.apiConfigurationService.loadConfiguration(this.User.companyId).subscribe();
          }

          this.fetchUserMenu()
          const host = window.location.host;

          if (host.includes('localhost') && this.User.companyId) {

            this.whileLabelService.CompanyWhiteLabel_readByTenantId({
              tenantId: this.User.companyId,
              tenantBranchId: this.User.loggedInBranchId
            }).subscribe(res => {

              this.loaderService.dismiss()
            })
          } else {

            const data: FilteredKeyValueRequestDTO = {
              dCode: 'HostCompanyId',
              tenantId: 1,
              tenantBranchId: 1,
              FilterValue: host
            };

            this.valueListService.ValueListItem_GetFilteredKeyValueDictionaryByCode(data).subscribe(res => {

              if (res.items.length > 0) {


                this.whileLabelService.CompanyWhiteLabel_readByTenantId({
                  tenantId: +res.items[0]?.key,
                  tenantBranchId: +(res.items[0]?.TenantBranchId ?? 0),
                }).subscribe(res => {
                  this.loaderService.dismiss()
                }
                )

              } else {

                this.loaderService.dismiss()

              }

            });

          }
          this.getWhiteLabelForCompany(this.User.companyId)
          this.checkSubscriptionStatus()



        },
        error: (err) => {


          this.Logout();
        },
      });
    } else {
      this.userLoginService.SignOutUser()
    }
  }

  checkSubscriptionStatus(): void {
    if (!this.User?.companyId) return;
    
    this.customerSubscriptionsService.CustomerSubscriptions_status({
      tenantId: this.User.companyId
    }).subscribe({
      next: (res) => {
        const items: CustomerSubscriptionsStatusDTO[] = res?.items || [];

        // Clear any stale expired-redirect flag — we no longer block app access
        if (sessionStorage.getItem('expiredSubscriptionData')) {
          sessionStorage.removeItem('expiredSubscriptionData');
          if (this.router.url.startsWith('/subscription-expired')) {
            this.router.navigate(['/']);
          }
        }

        // Payment due popup — driven from same Status API response
        const paymentItem = items.find(a => a.hasPaymentDue === 1) ?? null;
        if (paymentItem) {
          this.paymentDueData = paymentItem;
          this.buildPaymentQrCode(paymentItem);

          const sessionKey = 'paymentDueShownSession';

          // Load stored session data (shown flag + last known snapshot)
          let sessionData: { shown?: boolean; snapshot?: { paymentPhase: number; monthlyTotalAmount: number; overdueDays: number; endDate: string } } = {};
          try {
            const raw = sessionStorage.getItem(sessionKey);
            sessionData = raw ? JSON.parse(raw) : {};
          } catch { sessionData = {}; }

          // Build current snapshot for change detection
          const currentSnapshot = {
            paymentPhase: paymentItem.paymentPhase,
            monthlyTotalAmount: paymentItem.monthlyTotalAmount,
            overdueDays: paymentItem.overdueDays,
            endDate: paymentItem.endDate
          };

          // If snapshot exists and anything meaningful changed, reset shown flag
          if (sessionData.snapshot) {
            const prev = sessionData.snapshot;
            const changed = prev.paymentPhase !== currentSnapshot.paymentPhase
              || prev.monthlyTotalAmount !== currentSnapshot.monthlyTotalAmount
              || prev.overdueDays !== currentSnapshot.overdueDays
              || prev.endDate !== currentSnapshot.endDate;
            if (changed) {
              sessionData.shown = false;
            }
          }

          // Persist updated snapshot
          sessionData.snapshot = currentSnapshot;
          sessionStorage.setItem(sessionKey, JSON.stringify(sessionData));

          if (paymentItem.paymentPhase <= 2 && sessionData.shown) {
            // Phases 1-2: already shown this session and nothing changed
          } else {
            this.activePaymentDueAlert = paymentItem;
            if (paymentItem.paymentPhase <= 2) {
              sessionData.shown = true;
              sessionStorage.setItem(sessionKey, JSON.stringify(sessionData));
            }
            if (paymentItem.popupIntervalMinutes > 0) {
              this.schedulePaymentRepopup(paymentItem.popupIntervalMinutes * 60 * 1000);
            }
          }
        } else {
          this.paymentDueData = null;
          this.activePaymentDueAlert = null;
          this.clearPaymentDueTimer();
        }

        this.scheduleNextSubscriptionCheck();
        
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('[SubStatus] error:', err);
        // Retry after 5 minutes on error
        this.scheduleNextSubscriptionCheck(5 * 60 * 1000);
      }
    });
  }

  private scheduleNextSubscriptionCheck(forcedDelay?: number): void {
    // Clear any existing timer
    if (this.subscriptionCheckTimer) {
      clearTimeout(this.subscriptionCheckTimer);
      this.subscriptionCheckTimer = null;
    }

    // On error retry only
    if (forcedDelay) {
      this.subscriptionCheckTimer = setTimeout(() => {
        this.checkSubscriptionStatus();
      }, forcedDelay);
      return;
    }

    // No recurring checks — status is checked once on login.
    // The popup already tracks dismissal per day via localStorage.
  }

  // ─────────────────────────────────────────
  // Payment Due Popup
  // ─────────────────────────────────────────

  private buildPaymentQrCode(data: CustomerSubscriptionsStatusDTO): void {
    const amount = data.monthlyTotalAmount ? Math.round(data.monthlyTotalAmount) : null;
    const tenantId = this.User?.companyId ?? '';
    const tn = `AdvERP Payment | Tenant: ${tenantId} | Amt: INR ${amount}`;
    const amountParam = amount ? `&am=${amount}&tn=${encodeURIComponent(tn)}` : '';
    const upiString = `upi://pay?pa=${this.paymentBankDetails.upiId}&pn=${encodeURIComponent(this.paymentBankDetails.beneficiary)}&cu=INR${amountParam}`;
    const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(upiString)}`;
    this.paymentQrCodeUrl = this.sanitizer.bypassSecurityTrustUrl(qrApiUrl);
  }

  dismissPaymentPopup(): void {
    this.activePaymentDueAlert = null;
    this.showPaymentBankDetails = false;

    // For phases 3+, schedule repopup if timer not already pending
    if (this.paymentDueData && this.paymentDueData.popupIntervalMinutes > 0 && !this.paymentPopupTimer) {
      this.schedulePaymentRepopup(this.paymentDueData.popupIntervalMinutes * 60 * 1000);
    }
  }

  private schedulePaymentRepopup(intervalMs: number): void {
    this.clearPaymentDueTimer();
    this.paymentPopupTimer = setTimeout(() => {
      this.paymentPopupTimer = null;
      if (this.paymentDueData && this.paymentDueData.hasPaymentDue) {
        this.activePaymentDueAlert = this.paymentDueData;
        this.cdr.detectChanges();
        // Schedule next recurrence after this one is dismissed
      }
    }, intervalMs);
  }

  private clearPaymentDueTimer(): void {
    if (this.paymentPopupTimer) {
      clearTimeout(this.paymentPopupTimer);
      this.paymentPopupTimer = null;
    }
  }

  copyPaymentField(value: string, field: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.copiedPaymentField = field;
      setTimeout(() => { this.copiedPaymentField = null; }, 2000);
    });
  }

  private fetchUserMenu() {
    const body: SubRolesReadByUserIdRequestDTO = {
      userId: this.User.userId,
       tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      softwareId: +environment.SoftwareId
    };

    this.subRolesService.SubRoles_readByUserId(body).subscribe(userMenu => {

      let menulist = userMenu.items.map(res => res.subRoleCode)
      localStorage.setItem('menuList', menulist.toString())

      this.parentMenu = this.buildMenuTree(userMenu.items)
      this.menuById = new Map((userMenu.items || []).map(menu => [menu.menuId, menu]));
      this.companyCategoryService.FetchAllCategories();
      this.valueListService.FetchAllValueLists();
      this.locationService.fetchAllLocations();

      this.updateBreadcrumbs();

      this.loaderService.dismiss();
    });
  }

  Logout(): void {
    this.userLoginService.SignOutUser();
  }

  /** True when the menu is shown expanded (accordion). The <=786px drawer is always expanded: the vendor script's "condensed" mode is a desktop rail. */
  get isSidebarEnabled(): boolean {
    return window.innerWidth <= 786 || document.body.getAttribute('data-leftbar-compact-mode') !== 'condensed';
  }

  private bodyObserver?: MutationObserver;

  ngAfterViewInit(): void {
    // The menu mode lives in a body attribute/class (set by the vendor theme script and by applyMenuState): re-render when it changes
    this.bodyObserver = new MutationObserver(() => {
      this.cdr.detectChanges();
    });
    this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'data-leftbar-compact-mode'] });

    this.initClarityShell();

    // Hide mobile breadcrumb strip on scroll — throttled, auto-cleaned on destroy
    const contentPage = document.querySelector('.content-page') as HTMLElement;
    if (contentPage) {
      fromEvent(contentPage, 'scroll')
        .pipe(
          throttleTime(80, undefined, { leading: true, trailing: true }),
          takeUntil(this.destroy$)
        )
        .subscribe(() => {
          this.mobileBreadcrumbHidden = contentPage.scrollTop > 10;
          this.cdr.markForCheck();
        });
    }
  }

  ngOnDestroy(): void {
    this.bodyObserver?.disconnect();
    this.destroy$.next();
    this.destroy$.complete();
    
    // Clear subscription check timer
    if (this.subscriptionCheckTimer) {
      clearTimeout(this.subscriptionCheckTimer);
      this.subscriptionCheckTimer = null;
    }

    // Clear payment due repopup timer
    this.clearPaymentDueTimer();
  }

  buildMenuTree(menuItems: SubRoleMenuDTO[], parentId: number = 0): SubRoleMenuDTO[] {
    return menuItems
      .filter(menu => menu.parentMenuId === parentId)
      .map(menu => ({
        ...menu,
        childMenuList: this.buildMenuTree(menuItems, menu.menuId)
      }));
  }

  private setupBreadcrumbTracking(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateBreadcrumbs();
        document.body.classList.remove('sidebar-enable');
      });
  }

  private updateBreadcrumbs(): void {
    const currentUrl = this.normalizeUrl(this.router.url);
    const urlSegments = currentUrl.split('/').filter(Boolean);
    const leafRouteTitle = this.getDeepestRouteTitle();

    if (urlSegments.length < 2 || this.parentMenu.length === 0) {
      this.breadcrumbItems = [];
      return;
    }

    const moduleCode = urlSegments[0].toLowerCase();
    const pageCode = this.getBreadcrumbPageCode(moduleCode, urlSegments[1]);
    const hasDetailSegment = urlSegments.length > 2;

    const originTrail = this.getOriginTrailForDetailRoute(hasDetailSegment, currentUrl);
    if (originTrail && originTrail.length > 0) {
      const crumbs: BreadcrumbItem[] = [...originTrail];
      const detailLeafLabel = leafRouteTitle || this.toReadableText(urlSegments[1]);
      const lastLabel = crumbs[crumbs.length - 1].label.trim().toLowerCase();

      if (detailLeafLabel.trim().toLowerCase() !== lastLabel) {
        crumbs.push({
          label: detailLeafLabel,
          url: currentUrl,
          clickable: false
        });
      }

      if (crumbs.length > 0) {
        crumbs.forEach((crumb, index) => (crumb.clickable = index !== 0));
        crumbs[crumbs.length - 1].clickable = false;
      }

      this.breadcrumbItems = crumbs;
      return;
    }

    const moduleNode = this.parentMenu.find(menu =>
      (menu.subRoleCode || '').toLowerCase() === moduleCode
    );

    if (!moduleNode) {
      this.breadcrumbItems = [];
      return;
    }

    const targetNode = this.findDescendantByCode(moduleNode, pageCode);
    const crumbs: BreadcrumbItem[] = [
      {
        label: moduleNode.subRoleName || this.toReadableText(moduleNode.subRoleCode || moduleCode),
        url: `/${moduleNode.subRoleCode || moduleCode}`,
        clickable: false
      }
    ];

    if (targetNode) {
      const chainWithinModule = this.getChainWithinModule(moduleNode, targetNode);
      for (let i = 0; i < chainWithinModule.length; i++) {
        const chainNode = chainWithinModule[i];
        const codePath = chainWithinModule
          .slice(0, i + 1)
          .map(node => node.subRoleCode)
          .filter((code): code is string => !!code);

        if (codePath.length === 0) {
          continue;
        }

        crumbs.push({
          label: chainNode.subRoleName || this.toReadableText(chainNode.subRoleCode || ''),
          url: `/${moduleNode.subRoleCode}/${codePath.join('/')}`,
          clickable: true
        });
      }
    } else {
      const fallbackLeafLabel = leafRouteTitle || this.toReadableText(urlSegments[1]);
      crumbs.push({
        label: fallbackLeafLabel,
        url: `/${moduleNode.subRoleCode || moduleCode}/${urlSegments[1]}`,
        clickable: false
      });
    }

    if (leafRouteTitle && hasDetailSegment) {
      const lastLabel = crumbs.length > 0 ? crumbs[crumbs.length - 1].label.trim().toLowerCase() : '';
      const normalizedLeaf = leafRouteTitle.trim().toLowerCase();

      if (lastLabel !== normalizedLeaf) {
        crumbs.push({
          label: leafRouteTitle,
          url: currentUrl,
          clickable: false
        });
      }
    }

    if (crumbs.length > 0) {
      crumbs.forEach((crumb, index) => (crumb.clickable = index !== 0));
      crumbs[crumbs.length - 1].clickable = false;
    }

    this.breadcrumbItems = crumbs;
  }

  private findDescendantByCode(rootNode: SubRoleMenuDTO, code: string): SubRoleMenuDTO | null {
    const stack: SubRoleMenuDTO[] = [...(rootNode.childMenuList || [])];

    while (stack.length > 0) {
      const node = stack.shift() as SubRoleMenuDTO;

      if ((node.subRoleCode || '').toLowerCase() === code.toLowerCase()) {
        return node;
      }

      if (node.childMenuList && node.childMenuList.length > 0) {
        stack.push(...node.childMenuList);
      }
    }

    return null;
  }

  private getChainWithinModule(moduleNode: SubRoleMenuDTO, node: SubRoleMenuDTO): SubRoleMenuDTO[] {
    const chain: SubRoleMenuDTO[] = [];
    let current: SubRoleMenuDTO | undefined = node;

    while (current && current.menuId !== moduleNode.menuId) {
      chain.push(current);
      current = this.menuById.get(current.parentMenuId);
    }

    return chain.reverse();
  }

  private getDeepestRouteTitle(): string {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const title = route.snapshot.title;
    return typeof title === 'string' ? title : '';
  }

  navigateToBreadcrumb(crumb: BreadcrumbItem): void {
    if (!crumb.clickable || !crumb.url) {
      return;
    }

    this.router.navigateByUrl(crumb.url);
  }

  private toReadableText(value: string): string {
    if (!value) {
      return '';
    }

    return value
      .replace(/[-_]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  private getBreadcrumbPageCode(moduleCode: string, rawPageCode: string): string {
    const moduleAliases = this.breadcrumbRouteAliasMap[moduleCode] || {};
    return moduleAliases[rawPageCode.toLowerCase()] || rawPageCode;
  }

  private getOriginTrailForDetailRoute(
    hasDetailSegment: boolean,
    currentUrl: string
  ): BreadcrumbItem[] | null {
    if (!hasDetailSegment) {
      return null;
    }

    const previousUrl = this.navigationHistoryService.getPreviousUrl();
    if (!previousUrl) {
      return null;
    }

    const candidateUrl = this.normalizeUrl(previousUrl);
    if (!candidateUrl || candidateUrl === currentUrl) {
      return null;
    }

    const prevSegments = candidateUrl.split('/').filter(Boolean);
    // Only accept list-like origins (module/page), not deeper detail routes.
    if (prevSegments.length !== 2) {
      return null;
    }

    const prevModuleCode = prevSegments[0].toLowerCase();
    const prevModuleNode = this.parentMenu.find(menu =>
      (menu.subRoleCode || '').toLowerCase() === prevModuleCode
    );
    if (!prevModuleNode) {
      return null;
    }

    const prevPageCode = this.getBreadcrumbPageCode(prevModuleCode, prevSegments[1]);
    const prevNode = this.findDescendantByCode(prevModuleNode, prevPageCode);
    if (!prevNode) {
      return null;
    }

    return [
      {
        label: prevModuleNode.subRoleName || this.toReadableText(prevModuleNode.subRoleCode || prevModuleCode),
        url: `/${prevModuleNode.subRoleCode || prevModuleCode}`,
        clickable: false
      },
      {
        label: prevNode.subRoleName || this.toReadableText(prevPageCode),
        url: candidateUrl,
        clickable: true
      }
    ];
  }

  private normalizeUrl(url: string): string {
    return url.split('?')[0].split('#')[0];
  }

  whileLabelService = inject(WhiteLabelServiceService)
  whiteLabelDetails!: CompanyWhiteLabelDTO


  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/images/defaultUser.jpg';
  }

  getUserInitials(username: string): string {
    if (!username) return '';

    // Split by spaces and take first two letters
    const parts = username.split(' ');
    let initials = '';

    if (parts.length >= 2) {
      initials = parts[0].charAt(0) + parts[1].charAt(0);
    } else if (parts[0].length >= 2) {
      initials = parts[0].substring(0, 2);
    } else {
      initials = parts[0].charAt(0);
    }

    return initials.toUpperCase();
  }

  getWhiteLabelForCompany(companyId: number) {
    this.whileLabelService.$whiteLabelDetails.subscribe(res => {
      this.whiteLabelDetails = res as CompanyWhiteLabelDTO
      this.updateCompanyStyle()
    })
  }

  updateCompanyStyle() {
    if (this.whiteLabelDetails) {
      const { favicon, styleCss } = this.whiteLabelDetails;
      //insert new style
      const style = this.renderer.createElement('style');
      const css = styleCss;
      this.renderer.appendChild(style, this.renderer.createText(css as string));
      this.renderer.appendChild(document.head, style);


      if (favicon) {
        let faviconLink = document.querySelector("link[rel~='icon']") as HTMLLinkElement;

        if (!faviconLink) {
          faviconLink = document.createElement('link');
          faviconLink.rel = 'icon';
          document.head.appendChild(faviconLink);
        }
        faviconLink.href = `${favicon}?v=${new Date().getTime()}`;
      }
      this.loaderService.dismiss()

    }
  }
  openMyAccount() {
    const userId = this.User.userId;
    const payload: IndividualMasterReadByUserIdRequestDTO = {
      userId: userId,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
    }

    this.individualService
      .IndividualMaster_readByUserId(payload)
      .subscribe(res => {
        if (res?.indId) {
          this.router.navigate(['/hrms/staff-master', res.indId], { queryParams: { branchId: this.User.loggedInBranchId } });
        }
      });
  }

  changeBranchModal!: NgbModalRef;
  public modalService = inject(NgbModal)
  @ViewChild('branchModal', { static: false }) branchModalContent!: ElementRef;
  changeBranch() {
    this.changeBranchModal = this.modalService.open(this.branchModalContent, { windowClass: 'cl-bm-window', centered: true })
  }

  selectBranch(branch: BranchMasterDTO) {
    this.loaderService.show();

    // Update User object
    this.User.loggedInBranchId = branch.tenantBranchId;

    // Update all localStorage items
    this.userLoginService.saveUserData(this.User);
    localStorage.setItem('loggedInBranchId', branch.tenantBranchId.toString());
    localStorage.setItem('selected_branch', JSON.stringify(branch));
    this.fetchUserMenu(); // Refresh menu for new branch

    setTimeout(() => {
      window.location.reload(); // Reload the page to apply changes
    }, 300);

    // Close modal
    this.changeBranchModal.close();
  }

  closeBranchModal() {
    this.changeBranchModal.close();
  }

  // ─────────────────────────────────────────
  // "Clarity" shell UI layer: styling hooks (`cl-shell` on the root `.wrapper`, styles in src/styles.css), collapse state,
  // menu search, floating scrollbars, selected-item highlight, hover-card placement and the page-load bar.
  // Menu loading, accordion, flyout content, branch switching and the user dropdown handlers are the app's own.
  // ─────────────────────────────────────────

  // ----- collapse state: remembered choice, else automatic by screen width (desktop/tablet); the <=786px drawer is always expanded -----
  // The vendor theme script (assets/js/app.min.js) expands/collapses by width on every resize and forgets what the user chose.
  // This runs after it (our resize listener is registered later) and puts the menu in the state below.
  private readonly menuCollapseKey = 'cl_menu_collapsed';          // '1' collapsed, '0' expanded; absent = never chosen
  private readonly menuAutoCollapseMaxWidth = 1100;                 // never chosen: collapsed at this width and narrower, expanded above

  private readMenuChoice(): boolean | null {
    try {
      const v = localStorage.getItem(this.menuCollapseKey);
      return v === '1' ? true : v === '0' ? false : null;
    } catch {
      return null;
    }
  }

  private applyMenuState(): void {
    const body = document.body;
    const isCollapsed = body.getAttribute('data-leftbar-compact-mode') === 'condensed';
    if (window.innerWidth <= 786) {
      // phone drawer: the vendor script sets "condensed" on a hamburger tap (and at 750-786px), which turned the drawer into the
      // desktop icon rail (two logos, hover cards instead of the accordion). The drawer is always the expanded menu.
      if (isCollapsed) {
        body.removeAttribute('data-leftbar-compact-mode');
      }
      return;
    }
    const choice = this.readMenuChoice();
    const collapse = choice !== null ? choice : window.innerWidth <= this.menuAutoCollapseMaxWidth;
    if (collapse === isCollapsed) {
      return;
    }
    if (collapse) {
      body.setAttribute('data-leftbar-compact-mode', 'condensed');
    } else {
      body.removeAttribute('data-leftbar-compact-mode');
    }
  }

  /** Called after the user clicks the collapse / expand button: whatever state the vendor toggle left is now their choice. */
  private rememberMenuChoice(): void {
    if (window.innerWidth <= 786) {
      return;
    }
    try {
      localStorage.setItem(this.menuCollapseKey, document.body.getAttribute('data-leftbar-compact-mode') === 'condensed' ? '1' : '0');
    } catch {
      // storage blocked: the choice simply does not persist
    }
  }

  @ViewChild('clIndicator') clIndicator?: ElementRef<HTMLElement>;
  @ViewChild('clProgress') clProgress?: ElementRef<HTMLElement>;

  // ----- top page-load bar: starts when a route navigation starts (a different page, not just a query-string change),
  //       creeps towards ~85% while the page/module loads, then completes and fades; always visible for at least 300ms -----
  private clProgActive = false;
  private clProgStartedAt = 0;
  private clProgTimer: any;

  private progressStart(): void {
    const el = this.clProgress?.nativeElement;
    if (!el) {
      return;
    }
    clearTimeout(this.clProgTimer);
    this.clProgActive = true;
    this.clProgStartedAt = Date.now();
    el.style.transition = 'none';
    el.style.opacity = '1';
    el.style.transform = 'scaleX(0)';
    void el.offsetWidth;   // restart from 0
    el.style.transition = 'transform 10s cubic-bezier(.1, .7, .2, 1)';
    el.style.transform = 'scaleX(.85)';
  }

  private progressDone(): void {
    const el = this.clProgress?.nativeElement;
    if (!el || !this.clProgActive) {
      return;
    }
    this.clProgActive = false;
    const wait = Math.max(0, 300 - (Date.now() - this.clProgStartedAt));
    this.clProgTimer = setTimeout(() => {
      el.style.transition = 'transform .2s ease-out, opacity .35s ease .15s';
      el.style.transform = 'scaleX(1)';
      el.style.opacity = '0';
    }, wait);
  }
  @ViewChild('clCmdInput') clCmdInput?: ElementRef<HTMLInputElement>;
  @ViewChild('clCmdList') clCmdList?: ElementRef<HTMLElement>;

  private ngZone = inject(NgZone);
  private clScrollers: ModernScrollHandle[] = [];
  private clObservers: MutationObserver[] = [];
  private clRaf = 0;

  // Menu search (Ctrl+K)
  cmdOpen = false;
  cmdQuery = '';
  cmdIndex = 0;
  cmdResults: ShellSearchItem[] = [];
  private readonly cmdRecentKey = 'cl_menu_recents';

  /** First URL segment (the module code), lower-cased. */
  private get currentModuleCode(): string {
    const seg = this.normalizeUrl(this.router.url).split('/').filter(Boolean)[0];
    return (seg || '').toLowerCase();
  }

  /** True for the sidebar module that contains the page currently open. */
  isModuleCurrent(menu: SubRoleMenuDTO): boolean {
    return !!menu.subRoleCode && menu.subRoleCode.toLowerCase() === this.currentModuleCode;
  }

  /**
   * Collapsed-rail hover flyout: pops a sub-menu out to the right of its parent list using screen coordinates
   * (consumed by `position: fixed` in styles.css). The flyout scrolls vertically, so a sub-menu positioned inside
   * it was clipped and made the flyout scroll sideways.
   */
  clPlaceSub(event: Event): void {
    const li = event.currentTarget as HTMLElement;
    const parent = li.parentElement?.closest('.flyout-level2, .sidebar-flyout') as HTMLElement | null;
    if (!parent) {
      return;
    }
    const pr = parent.getBoundingClientRect();
    const lr = li.getBoundingClientRect();
    li.style.setProperty('--cl-fl-left', (pr.right - 1) + 'px');
    li.style.setProperty('--cl-fl-top', Math.max(8, lr.top - 5) + 'px');
  }

  /** Header copy of the user menu trigger: opens the existing user dropdown, aligned to the right edge. */
  toggleHeaderUserDropdown(event: MouseEvent): void {
    event.preventDefault();
    if (this.userDropdownOpen) {
      this.userDropdownOpen = false;
      return;
    }
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    this.userDropdownStyle = {
      position: 'fixed',
      top: rect.bottom + 6 + 'px',
      right: Math.max(8, window.innerWidth - rect.right) + 'px',
      zIndex: '9999',
      minWidth: '200px'
    };
    this.userDropdownOpen = true;
  }

  // ----- menu search -----

  @HostListener('document:keydown', ['$event'])
  onShellKeydown(event: KeyboardEvent): void {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this.cmdOpen ? this.closeCmd() : this.openCmd();
    } else if (event.key === 'Escape' && this.cmdOpen) {
      this.closeCmd();
    }
  }

  openCmd(): void {
    if (this.parentMenu.length === 0) {
      return;
    }
    this.cmdQuery = '';
    this.cmdOpen = true;
    this.refreshCmd();
    setTimeout(() => this.clCmdInput?.nativeElement.focus(), 0);
  }

  closeCmd(): void {
    this.cmdOpen = false;
  }

  onCmdInput(event: Event): void {
    this.cmdQuery = (event.target as HTMLInputElement).value;
    this.refreshCmd();
  }

  onCmdKey(event: KeyboardEvent): void {
    const n = this.cmdResults.length;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (n === 0) {
        return;
      }
      // wraps around at both ends
      this.cmdIndex = (this.cmdIndex + (event.key === 'ArrowDown' ? 1 : -1) + n) % n;
      this.scrollCmdSelectionIntoView();
    } else if (event.key === 'Enter') {
      event.preventDefault();
      this.runCmd(this.cmdResults[this.cmdIndex]);
    }
  }

  runCmd(item?: ShellSearchItem): void {
    if (!item || item.path.some(p => !p)) {
      return;
    }
    this.closeCmd();
    this.saveCmdRecent(item.path);
    // same relative navigation the sidebar's [routerLink] arrays perform
    this.router.navigate(item.path, { relativeTo: this.activatedRoute });
  }

  /** The list is a scroll box: keep the keyboard-selected row visible (after Angular has moved the .sel class). */
  private scrollCmdSelectionIntoView(): void {
    setTimeout(() => {
      this.clCmdList?.nativeElement.querySelector('.cl-cmdk-it.sel')?.scrollIntoView({ block: 'nearest' });
    }, 0);
  }

  /** Mouse selects a row only when it really moves, so a resting pointer does not steal the keyboard selection while the list scrolls. */
  onCmdMouseMove(i: number): void {
    if (this.cmdIndex !== i) {
      this.cmdIndex = i;
    }
  }

  trackCmd(_: number, item: ShellSearchItem): string {
    return item.path.join('/');
  }

  /** Mirrors the template's sidebar logic (levels, childIsParent) so every result is a real sidebar route. */
  private flattenMenu(): ShellSearchItem[] {
    const out: ShellSearchItem[] = [];
    for (const m of this.parentMenu) {
      const mCode = m.subRoleCode ?? '';
      const mName = m.subRoleName ?? '';
      const icon = m.menuIconUrl || 'mdi mdi-layers-outline';
      const children = m.childMenuList ?? [];
      if (children.length === 0) {
        out.push({ label: mName, trail: '', icon, path: [mCode] });
        continue;
      }
      for (const c of children) {
        const cName = c.subRoleName ?? '';
        const isGroup = !!c.childMenuList && c.childMenuList.length > 0 && !c.childIsParent;
        if (!isGroup) {
          out.push({ label: cName, trail: mName, icon, path: [mCode, c.subRoleCode ?? ''] });
          continue;
        }
        for (const s of c.childMenuList) {
          const sName = s.subRoleName ?? '';
          if (s.childMenuList && s.childMenuList.length > 0) {
            for (const f of s.childMenuList) {
              out.push({ label: f.subRoleName ?? '', trail: `${mName} › ${cName} › ${sName}`, icon, path: [mCode, c.subRoleCode ?? '', s.subRoleCode ?? '', f.subRoleCode ?? ''] });
            }
          } else {
            out.push({ label: sName, trail: `${mName} › ${cName}`, icon, path: [mCode, c.subRoleCode ?? '', s.subRoleCode ?? ''] });
          }
        }
      }
    }
    return out.filter(i => i.label && i.path.every(p => !!p));
  }

  private refreshCmd(): void {
    const all = this.flattenMenu();
    const terms = this.cmdQuery.trim().toLowerCase().split(/\s+/).filter(Boolean);
    const key = (i: ShellSearchItem) => i.path.join('/');
    if (terms.length === 0) {
      const recent = this.readCmdRecents()
        .map(p => all.find(a => key(a) === p.join('/')))
        .filter((x): x is ShellSearchItem => !!x)
        .slice(0, 5)
        .map(x => ({ ...x, group: 'Recent' }));
      const rest = all.filter(a => !recent.some(r => key(r) === key(a))).slice(0, 8).map(x => ({ ...x, group: 'Menu' }));
      this.cmdResults = [...recent, ...rest];
    } else {
      // match only the page's own name (the subRoleName the user sees in the sidebar), not its module/group path;
      // rank: name starts with the query, then a word in the name starts with it, then anywhere in the name
      const q = terms.join(' ');
      const rank = (label: string) => {
        const l = label.toLowerCase();
        const words = l.split(/[\s\-_/()]+/);
        return l.startsWith(q) ? 0 : terms.every(t => words.some(w => w.startsWith(t))) ? 1 : 2;
      };
      this.cmdResults = all
        .filter(a => terms.every(t => a.label.toLowerCase().includes(t)))
        .map(a => ({ a, r: rank(a.label) }))
        .sort((x, y) => x.r - y.r || x.a.label.localeCompare(y.a.label))
        .slice(0, 20)
        .map(x => ({ ...x.a, group: 'Pages' }));
    }
    this.cmdIndex = 0;
  }

  private readCmdRecents(): string[][] {
    try {
      const raw = JSON.parse(localStorage.getItem(this.cmdRecentKey) || '[]');
      return Array.isArray(raw) ? raw.filter(p => Array.isArray(p)) : [];
    } catch {
      return [];
    }
  }

  private saveCmdRecent(path: string[]): void {
    try {
      const next = [path, ...this.readCmdRecents().filter(p => p.join('/') !== path.join('/'))].slice(0, 6);
      localStorage.setItem(this.cmdRecentKey, JSON.stringify(next));
    } catch { /* storage unavailable: recents are optional */ }
  }

  // ----- selected-item highlight + floating scrollbars -----

  private initClarityShell(): void {
    const nav = document.getElementById('leftside-menu-container');
    const contentPage = document.querySelector('.content-page') as HTMLElement | null;

    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'resize').pipe(takeUntil(this.destroy$)).subscribe(() => this.applyMenuState());
      fromEvent(document, 'click')
        .pipe(
          filter(e => !!(e.target as HTMLElement | null)?.closest?.('.mdi-chevron-double-left, .mdi-chevron-double-right, .button-menu-mobile')),
          takeUntil(this.destroy$)
        )
        .subscribe(() => setTimeout(() => {
          this.rememberMenuChoice();   // desktop/tablet: the user's toggle is their choice
          this.applyMenuState();       // phone: undo the vendor script's "condensed"
        }, 0));
      if (nav) {
        this.clScrollers.push(attachModernScroll(nav, { z: 1100, fade: true }));
        // the accordion animates its height: re-aim the highlight once it has really finished, so it never stays where it was
        // last placed mid-animation (the per-frame tracking can stop early when the browser throttles frames)
        fromEvent<TransitionEvent>(nav, 'transitionend')
          .pipe(filter(e => !!(e.target as HTMLElement | null)?.classList?.contains('menu-submenu')), takeUntil(this.destroy$))
          .subscribe(() => this.positionIndicator(false));
        const moves = ['menu-open', 'menu-submenu-open', 'cl-active', 'cl-current'];
        const navObserver = new MutationObserver(records => {
          // hover and hover-source classes flip constantly in the rail; only changes that can move the highlight re-measure
          const relevant = records.some(r => {
            if (r.type === 'childList') {
              return true;
            }
            const before = new Set((r.oldValue || '').split(/\s+/));
            const after = new Set(((r.target as HTMLElement).className || '').toString().split(/\s+/));
            return moves.some(c => before.has(c) !== after.has(c));
          });
          if (relevant) {
            this.trackIndicator(400);
          }
        });
        navObserver.observe(nav, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
        this.clObservers.push(navObserver);
        fromEvent(nav, 'click').pipe(takeUntil(this.destroy$)).subscribe(() => this.trackIndicator(400));
      }
      if (contentPage) {
        this.clScrollers.push(attachModernScroll(contentPage));
      }
      // The collapsed-rail hover flyout and its sub-menus are created/removed by the template (*ngIf). Keep every one of them
      // between the header and the footer, size it to the space that is really available, and give it the floating
      // scrollbar (which only shows when its content overflows).
      const sidebar = document.querySelector('.leftside-menu');
      if (sidebar) {
        const popups = new Map<HTMLElement, ModernScrollHandle>();
        const fitPopup = (el: HTMLElement, desiredTop: number) => {
          const wrapper = document.querySelector('.wrapper.cl-shell') as HTMLElement | null;
          const cs = wrapper ? getComputedStyle(wrapper) : null;
          const hdr = (cs && parseFloat(cs.getPropertyValue('--cl-hdr'))) || 56;
          const topMin = hdr + 6;
          const bottomMax = window.innerHeight - 8;
          const maxHeight = Math.max(120, bottomMax - topMin) + 'px';
          if (el.style.maxHeight !== maxHeight) {
            el.style.maxHeight = maxHeight;
          }
          const top = Math.round(Math.max(topMin, Math.min(desiredTop, bottomMax - el.offsetHeight))) + 'px';
          if (el.style.top !== top) {
            el.style.top = top;
          }
        };
        const syncPopups = () => {
          const live = new Set<HTMLElement>();
          const first = sidebar.querySelector('.sidebar-flyout') as HTMLElement | null;
          if (first) {
            live.add(first);
            fitPopup(first, this.flyoutY);
            // the pointer notch sits on the hovered icon's centre line, kept inside the card's height
            const notch = sidebar.querySelector('.cl-fl-notch') as HTMLElement | null;
            if (notch) {
              const fr = first.getBoundingClientRect();
              const y = Math.round(Math.max(fr.top + 16, Math.min(this.flyoutAnchorY, fr.bottom - 16))) - 14 + 'px';
              if (notch.style.top !== y) {
                notch.style.top = y;
              }
            }
          }
          sidebar.querySelectorAll('.flyout-level2, .flyout-level3').forEach(node => {
            const el = node as HTMLElement;
            live.add(el);
            const li = el.parentElement;
            fitPopup(el, li ? li.getBoundingClientRect().top - 5 : 0);
          });
          live.forEach(el => {
            if (popups.has(el)) {
              popups.get(el)!.update();
            } else {
              popups.set(el, attachModernScroll(el, {
                z: 10002,
                top: () => (el.querySelector(':scope > .flyout-header') as HTMLElement | null)?.offsetHeight ?? 0
              }));
            }
          });
          popups.forEach((handle, el) => {
            if (!live.has(el)) {
              handle.destroy();
              popups.delete(el);
            }
          });
        };
        const popupObserver = new MutationObserver(syncPopups);
        popupObserver.observe(sidebar, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
        this.clObservers.push(popupObserver);
        this.destroy$.subscribe(() => popups.forEach(handle => handle.destroy()));
      }
      const bodyObserver = new MutationObserver(() => this.trackIndicator(400));
      bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['data-leftbar-compact-mode'] });
      this.clObservers.push(bodyObserver);
      fromEvent(window, 'resize').pipe(takeUntil(this.destroy$)).subscribe(() => this.trackIndicator(300));
    });

    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          if (event.url.split('?')[0].split('#')[0] !== this.router.url.split('?')[0].split('#')[0]) {
            this.progressStart();
          }
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.progressDone();
        }
      });
    this.destroy$.subscribe(() => clearTimeout(this.clProgTimer));

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe(() => {
        this.trackIndicator(400, true);
        setTimeout(() => this.popCurrentIcon(), 80);
      });

    this.destroy$.subscribe(() => {
      cancelAnimationFrame(this.clRaf);
      this.clObservers.forEach(o => o.disconnect());
      this.clScrollers.forEach(s => s.destroy());
    });

    this.trackIndicator(400, true);
  }

  private popCurrentIcon(): void {
    const icon = document.querySelector('#leftside-menu-container a.side-nav-link.cl-current i') as HTMLElement | null;
    if (!icon) {
      return;
    }
    icon.classList.remove('cl-ico-pop');
    void icon.offsetWidth;
    icon.classList.add('cl-ico-pop');
  }

  /**
   * Keeps the selected-item highlight on its row for `ms` milliseconds while the layout animates (accordion, collapse).
   * During that time the highlight is placed exactly each frame (CSS transition off); with `glide` (a page change) it keeps its
   * slide transition and is only re-aimed when its target really moved. Rail fit and scrollbars are not re-measured per frame.
   */
  private trackIndicator(ms: number, glide = false): void {
    this.ngZone.runOutsideAngular(() => {
      cancelAnimationFrame(this.clRaf);
      const indicator = this.clIndicator?.nativeElement;
      this.updateRailFit();
      const t0 = performance.now();
      let frame = 0;
      const step = () => {
        const first = frame === 0;
        this.positionIndicator(!glide || (first && !indicator?.classList.contains('on')));
        if (frame % 6 === 0) {
          this.clScrollers.forEach(s => s.update());
        }
        frame++;
        if (performance.now() - t0 < ms) {
          this.clRaf = requestAnimationFrame(step);
        } else {
          this.clScrollers.forEach(s => s.update());
          indicator?.classList.remove('snap');
        }
      };
      step();
    });
  }

  /**
   * Collapsed rail: shrink the module rows so every icon fits the available height. The rail only scrolls when the rows
   * would have to drop below a minimum size. (Expanded menu rows keep their normal height.)
   */
  private updateRailFit(): void {
    const nav = document.getElementById('leftside-menu-container');
    if (!nav) {
      return;
    }
    const condensed = document.body.getAttribute('data-leftbar-compact-mode') === 'condensed' && window.innerWidth > 786;
    const items = nav.querySelectorAll('.side-nav > .side-nav-item').length;
    if (!condensed || items === 0) {
      if (nav.style.getPropertyValue('--cl-row-fit')) {
        nav.style.removeProperty('--cl-row-fit');
      }
      return;
    }
    const cs = getComputedStyle(nav);
    const avail = nav.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    const wrapper = nav.closest('.wrapper') as HTMLElement | null;
    const row = (wrapper && parseFloat(getComputedStyle(wrapper).getPropertyValue('--cl-row'))) || 40;
    const fit = Math.max(32, Math.min(row, Math.floor(avail / items) - 2)) + 'px';   // each rail item also has a 1px margin top and bottom
    if (nav.style.getPropertyValue('--cl-row-fit') !== fit) {
      nav.style.setProperty('--cl-row-fit', fit);
    }
  }

  private positionIndicator(snap: boolean): void {
    const nav = document.getElementById('leftside-menu-container');
    const indicator = this.clIndicator?.nativeElement;
    if (!nav || !indicator) {
      return;
    }

    // visible = not inside a collapsed (.menu-submenu without -open) ancestor
    const isShown = (el: HTMLElement): boolean => {
      if (!el.offsetParent) {
        return false;
      }
      for (let p = el.parentElement; p && p !== nav; p = p.parentElement) {
        if (p.classList.contains('menu-submenu') && !p.classList.contains('menu-submenu-open')) {
          return false;
        }
      }
      return true;
    };

    let target = nav.querySelector('a.cl-active') as HTMLElement | null;
    if (!target || !isShown(target)) {
      target = nav.querySelector('a.side-nav-link.cl-current') as HTMLElement | null;
    }
    if (!target) {
      if (indicator.classList.contains('on')) {
        indicator.classList.remove('on');
      }
      return;
    }

    const r = target.getBoundingClientRect();
    const n = nav.getBoundingClientRect();
    if (snap && !indicator.classList.contains('snap')) {
      indicator.classList.add('snap');
    }
    const width = r.width + 'px';
    const height = r.height + 'px';
    const transform = `translate(${r.left - n.left + nav.scrollLeft}px, ${r.top - n.top + nav.scrollTop}px)`;
    if (indicator.style.width !== width) {
      indicator.style.width = width;
    }
    if (indicator.style.height !== height) {
      indicator.style.height = height;
    }
    if (indicator.style.transform !== transform) {
      indicator.style.transform = transform;
    }
    if (!indicator.classList.contains('on')) {
      indicator.classList.add('on');
    }
  }

}
